export default "__VITE_ASSET__B$AyjAtb__"